interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

const IconPlusCircle = ({
  width = 21,
  height = 20,
  color = "#515C6C",
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M10.4997 2.43018C14.6801 2.43018 18.0689 5.81917 18.069 9.99951C18.069 14.18 14.6802 17.5688 10.4997 17.5688C6.31936 17.5687 2.93036 14.1799 2.93036 9.99951C2.93053 5.81928 6.31946 2.43035 10.4997 2.43018ZM10.4997 3.68018C7.00982 3.68035 4.18053 6.50964 4.18036 9.99951C4.18036 13.4895 7.00971 16.3187 10.4997 16.3188C13.9898 16.3188 16.819 13.4896 16.819 9.99951C16.8189 6.50953 13.9897 3.68018 10.4997 3.68018ZM10.4997 6.59717C10.8449 6.59717 11.1247 6.87699 11.1247 7.22217V9.37451H13.278L13.404 9.38721C13.6886 9.44553 13.9029 9.69768 13.903 9.99951C13.903 10.3014 13.6887 10.5534 13.404 10.6118L13.278 10.6245H11.1247V12.7778C11.1246 13.1229 10.8448 13.4028 10.4997 13.4028C10.1547 13.4027 9.87481 13.1228 9.87469 12.7778V10.6245H7.72235C7.37717 10.6245 7.09735 10.3447 7.09735 9.99951C7.09752 9.65448 7.37728 9.37451 7.72235 9.37451H9.87469V7.22217C9.87469 6.8771 10.1547 6.59734 10.4997 6.59717Z"
        fill={color}
      />
    </svg>
  );
};

IconPlusCircle.displayName = "IconPlusCircle";

export default IconPlusCircle;
